import styled from "styled-components";

export const Step6Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;


export const TextWrapper = styled.div`
  padding: 15px;
  text-align: center;
  line-height: 300%;

  .title {
    font-weight: bold;
    font-size: 18px;
  }
`;